let AnchorMenuScroll = function (options) {
    let root = this;

    let vars = {
        elementDiv : '.anchor-menu-content',
    };

    this.construct = function (options) {
        registerScroll();
    };

    let registerScroll = function() {
        let anchorMenus = document.querySelectorAll(vars.elementDiv);
        anchorMenus.forEach(function(anchorMenu) {
            let anchorLinks = anchorMenu.querySelectorAll('a');
            anchorLinks.forEach(function(anchorLink) {
                if (anchorLink.getAttribute('href').startsWith('#')) {
                    anchorLink.addEventListener('click', function(event) {
                        setTimeout(function () {
                            window.scrollTo(window.scrollX, window.scrollY - 100);
                        }, 0);
                    });
                }
            });
        });
    }

    this.construct(options);
};

export {AnchorMenuScroll as default};
